module.exports = __webpack_public_path__ + "static/media/1_18_1.850259c9.jpg";